<template>
  <div class="py-5">
    <div class="title-wrapper dark">
      <span>
        <h1 class="font-bad font-weight-bold"> 
          Demo: Las 7 maravillas de Vue
        </h1>
      </span>
    </div>
    <main>
      <section 
        id="dynamic-components"
        class="container">
        <div 
          @click="toggleCollapseSection"
          :class="['section-title', collapseClass]">
          <h2> Componentes Dinamicos </h2>
          <span>
            <i class="fas fa-chevron-down section-chevron"></i>
          </span>
        </div>
        <transition name="drop">
          <div
            v-if="!sectionCollapsed"
            class="section-content my-4"
            >      
            <div class="row">
              <div class="col-12 col-sm-6 col-md-4"
                v-for="(category, id) in categories"
                :key="id">
                <div 
                  :class="['box', category.class]"
                  >
                  <h3 class="font-bad mb-4"> {{category.title}} </h3>
                  <IconCustom
                    :width="80"
                    :height="80">
                   
                    <component :is="category.iconComponent"/>
                  </IconCustom>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </section>

      <section >
        <b-container class="my-5">
          <CustomCard/>
        </b-container>
      </section>
    </main>
  </div>
</template>

<script>
import IconCustom from '@/components/IconCustom.vue'
import PuzzlePieceIcon from '@/components/icons/PuzzlePieceIcon.vue'
import IntegrationIcon from '@/components/icons/IntegrationIcon.vue'
import TransitionIcon from '@/components/icons/TransitionIcon.vue'
import CustomCard from '@/components/CustomCard.vue'

  export default {
    components: { 
      IconCustom,
      PuzzlePieceIcon,
      IntegrationIcon,
      TransitionIcon,
      CustomCard
    },
    data() {
      return {
        sectionCollapsed: true,

        categories: [
          {
            title: 'Easy Integration',
            class: 'blue-bg',
            iconComponent: 'IntegrationIcon',
          },
          {
            title: 'Dynamic Components',
            class: 'pink-bg',
            iconComponent: 'PuzzlePieceIcon',
          },
          {
            title: 'Animations',
            class: 'lightblue-bg',
            iconComponent: 'TransitionIcon',
          },
        ]
      }
    },
    methods:{
      toggleCollapseSection(){
        this.sectionCollapsed = !this.sectionCollapsed;
      }
    },
    computed:{
      collapseClass(){
        if(this.sectionCollapsed)
          return 'collapsed';
        return 'not-collapsed';
      }
    }
  }
</script>

<style>
.section-title{
  text-align: left;
   -webkit-box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);
  box-shadow: 0 7px 14px 0 rgba(0,0,0,.16);
  padding: 0.4rem 1rem;
  border-radius: 0 50px 50px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #2D4057;
  cursor: pointer;
}
.section-title >h2{
  font-size: 1.5rem;
}
.section-title.not-collapsed .section-chevron{
  transform: rotate(180deg);
}



.box{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  color: #fff;
}
.box > h3{
  font-weight: normal;
}
.blue-bg{
  background: #2D4057;
}
.pink-bg{
  background: #FA9483;
}
.lightblue-bg{
  background: #4097AA;
}

.section-content{
  overflow: hidden;
}
/* transition */
.drop-enter{
  height: 0;
}
.drop-enter-to{
  height: 220px;
}
.drop-enter-active{
  transition: height 0.5s ease-in;
}
.drop-leave{
  height: 220px;
}
.drop-leave-to{
  height: 0;
}
.drop-leave-active{
  transition: height 0.5s ease-out;
}
</style>